module.exports = __webpack_public_path__ + "components/weather-icon/static/nightthunderstorm@2-f327907bceb3938890b05ae12be54667.png";